import React from 'react';
import './ErrorPage.css';
import IconError from '../../common/icons/IconError';

const ErrorPage = ({ message, onRetry }) => {
  // Determine if error is retryable
  const isRetryableError = message.includes("connexion") || 
                          message.includes("réessayer") ||
                          message.includes("temporairement");

  return (
    <div className="error-container">
      <div className="error-content">
        <IconError />
        <h2>Oops! Une erreur s'est produite</h2>
        <p>{message}</p>
        {isRetryableError && onRetry && (
          <button className="retry-button" onClick={onRetry}>
            Réessayer
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorPage; 